// @flow

import { type PendingIncomingPayment } from './types';

export function getSafeOxxoUrl(incomingPayment: PendingIncomingPayment): string {
  const oxxoUrl = incomingPayment['oxxo_url'];
  if (!oxxoUrl)
    throw new Error('Oxxo: Invalid state - There is no oxxo_url property for this payment');

  return oxxoUrl;
}
